<template>
    <v-layout row wrap fill-height align-center justify-center class="py-5">
        <v-flex xs12 sm8 md7 lg6 xl4>
            <v-card>
                <v-card-text class="pa-4">
                    <h2 class="display-1 mb-4">Výběr metody platby</h2>
                    <v-form lazy-validation v-model="valid">
                        <v-radio-group v-model="payType" column>
                            <v-radio
                                    label="Hotově na místě"
                                    color="blue"
                                    value="cash"
                            ></v-radio>
                            <v-radio
                                    v-if="false"
                                    label="Kartou"
                                    color="blue"
                                    value="card"
                            ></v-radio>

                        </v-radio-group>

                        <v-layout row wrap fill-height align-center justify-space-between>
                            <v-btn
                                    class="ma-0"
                                    color="primary"
                                    @click="back"
                            >Zpět
                            </v-btn>

                            <v-btn
                                    class="ma-0"
                                    :disabled="!valid"
                                    color="primary"
                                    @click="next"
                            >Pokračovat
                            </v-btn>
                        </v-layout>

                    </v-form>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import Footer from '@/components/Footer'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            'footer-nav': Footer
        },
        data() {
            return {
                valid: true,
                payType: '',
            }
        },
        computed: {
            ...mapGetters([
                'getPayType',
            ]),
        },
        methods: {
            back() {
                this.$store.commit('setActualStep', 3);
                this.$router.push('step-3');
            },
            next() {
                this.$store.dispatch('setPayType', this.payType).then(() => {
                    this.$router.push('step-5')
                })
            }
        },
        mounted() {
            this.payType = this.getPayType;
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Step4.vue